/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.18.0
 */

import classNames from 'classnames';
import { useFormikContext } from 'formik';

import FormField, { IFormFieldProps } from '../../../modules/form/components/FormField';
import { IOptionItemProps } from '../Select/Select';
import { FormFieldWeekStyled } from './styled/FormFieldWeekStyled';

interface IFormFieldWeek extends IFormFieldProps {
    weekOptions: IOptionItemProps[];
    onSelectWeek?: (data: IOptionItemProps) => void;
}

const FormFieldWeek = ({ weekOptions, ...props }: IFormFieldWeek) => {
    const { setFieldValue } = useFormikContext();

    return (
        <FormField {...props}>
            {({ field, dataName }) => {

                const onSelectHandler = (value: IOptionItemProps) => {
                    if (props.onSelectWeek) {
                        props.onSelectWeek(value);
                    }
                    setFieldValue(field.name, value);
                };

                return <FormFieldWeekStyled data-name={dataName}>
                    {weekOptions.map((week: IOptionItemProps) =>
                        <div
                            className={classNames({ selected: field.value?.value === week.value })}
                            onClick={() => onSelectHandler(week)}
                        >
                            {week.label}
                        </div>,
                    )}
                </FormFieldWeekStyled>;
            }}
        </FormField>
    );
};

export default FormFieldWeek;
